import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleInvoices = React.lazy(() => import('./index'));
const ArticleInvoiceTable = React.lazy(() => import('./articleInvoiceTable'));
const ArticleInvoice = React.lazy(() => import('./articleInvoice'));
const ArticleInvoiceDetail = React.lazy(() => import('./articleInvoiceDetail'));

export const useArticleInvoiceRoutes = () => {

    return (
        <Route path="articleInvoices" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleInvoices /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleInvoiceTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleInvoice/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleInvoiceDetail/></Suspense> } />
            </Route>
        </Route>
    )
}